import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import {
  AddressMasterRequestParams,
  AreaData,
  CityData,
  HoodData,
} from '@y2/api-clients/address-master-v1';
import { getAddressMaster } from './address-fetcher';
import pickBy from 'lodash/pickBy';

const getQueryKey = ({
  topArea,
  area,
  city,
  neighborhood,
}: AddressMasterRequestParams) => [
  'address-master',
  pickBy({
    topArea,
    area,
    city,
    neighborhood,
  }),
];

const getFetchMethod = async (query: AddressMasterRequestParams) => {
  const {
    data: {
      data: {
        data: [address],
      },
    },
  } = await getAddressMaster(query);

  return address as AddressMasterResponse;
};

export type AddressMasterResponse = AreaData | CityData | HoodData | undefined;

export const getAddressMasterOptions = (
  query: AddressMasterRequestParams,
): UseQueryOptions<AddressMasterResponse> => ({
  queryKey: getQueryKey(query),
  queryFn: () => getFetchMethod(query),
});

export const useGetAddressMaster = (query: AddressMasterRequestParams) =>
  useQuery(getAddressMasterOptions(query));
